import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ban100 from "../../../assets/ban100.png";
import ban100popupimage from "../../../assets/ban100popupimage.png";

export default function CdtListItem({ openInvestmentPopup }) {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleSupportClick = () => {
    navigate("/vincula-tus-finanzas");
  };

  return (
    <div className="relative">
      <div className="bg-[#cfe3fb] pt-4 px-4 pb-1 rounded-xl shadow-[0px_4px_6px_rgba(0,0,0,0.4)] border-black-100">
        <div className="grid grid-cols-5 gap-4">
          <div className="flex flex-col items-center">
            <img src={ban100} alt="Ban100" className="w-40 h-auto mb-2" />
            <button
              type="button"
              onClick={togglePopup}
              className="text-[#033a88] font-bold underline mb-1 focus:outline-none"
            >
              Conoce más sobre Ban100
            </button>
            <p className="text-[#0054c9] font-bold">Calificación: AA-</p>
          </div>
          <div className="bg-[#fed6d6] p-3 rounded-lg text-center">
            <p className="font-bold text-red-600">6 meses</p>
            <p className="text-lg font-bold text-[#650305]">💲5.255.949</p>
            <p className="text-sm font-bold text-red-600">Tasa 10,5%</p>
          </div>
          <div className="bg-[#fbfed6] p-3 rounded-lg text-center">
            <p className="font-bold text-yellow-600">12 meses</p>
            <p className="text-lg font-bold text-[#656303]">💲5.535.000</p>
            <p className="text-sm font-bold text-yellow-600">Tasa 10,7%</p>
          </div>
          <div className="bg-[#d6fed6] p-3 rounded-lg text-center">
            <p className="font-bold text-green-600">18 meses</p>
            <p className="text-lg font-bold text-[#03650a]">💲5.815.709</p>
            <p className="text-sm font-bold text-green-600">Tasa 10,4%</p>
          </div>
          <div className="flex items-center justify-center">
            <button
              onClick={openInvestmentPopup}
              className="bg-[#36a31a] text-white font-bold py-1 px-4 rounded-lg hover:bg-[#55b03e] shadow-[0px_4px_8px_rgba(0,0,0,0.5)]"
            >
              ¡Abre tu CDT!
            </button>

          </div>
        </div>
        <hr className="border-t border-gray-400 mt-4" />

        <div className="grid grid-cols-3 gap-2">
          <button className="text-[#022351] font-bold text-left">↓ Información general</button>
          <button className="text-[#022351] font-bold text-center">↓ ¿Por qué nos gusta?</button>
          <button className="text-[#022351] font-bold text-right">↓ Seguro de Inversión</button>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={(e) => { if (e.target === e.currentTarget) togglePopup(); }}>
          <div className="bg-[#e8f2f4] rounded-xl px-6 pt-10 pb-2 w-[500px] text-center relative">
            <button
              onClick={togglePopup}
              className="absolute top-2 right-2 text-[#033a88] text-2xl font-bold hover:text-[#022351]"
            >
              ✕
            </button>
            <h2 className="text-[#004cb6] text-2xl font-bold mb-4">Confírmanos tus datos de inversión con</h2>
            <img src={ban100popupimage} alt="Ban100" className="w-40 mb-4" />
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-left text-[#004cb6] font-bold">Tu inversión por</p>
                <input type="text" defaultValue="$5.000.000" className="w-full p-2 bg-[#cfe3fb] rounded-lg" />
              </div>
              <div>
                <p className="text-left text-[#004cb6] font-bold">Que me entregará</p>
                <div className="bg-[#36a31a] text-white font-bold p-2 rounded-lg">$5.815.709</div>
              </div>
              <div>
                <p className="text-left text-[#004cb6] font-bold">Por esperar un plazo de</p>
                <select
                  defaultValue="18 meses"
                  className="text-[#032c65] w-full p-2 bg-[#cfe3fb] rounded-lg"
                >
                  <option value="6 meses">6 meses</option>
                  <option value="12 meses">12 meses</option>
                  <option value="18 meses">18 meses</option>
                </select>
              </div>
              <div>
                <p className="text-left text-[#004cb6] font-bold">A una rentabilidad del</p>
                <div className="bg-[#36a31a] text-white font-bold p-2 rounded-lg">10.6% EA</div>
              </div>
            </div>
            <button
              onClick={togglePopup}
              className="bg-[#36a31a] text-white font-bold py-2 px-6 rounded-lg w-full mt-4 hover:bg-[#55b03e]"
            >
              Confirmar datos
            </button>
            <div className="mt-2 bg-transparent rounded-lg w-full text-center">
              <button
                type="button"
                onClick={handleSupportClick}
                className="text-[#2860ad] text-sm font-bold hover:underline focus:outline-none"
              >
                ¿Necesitas ayuda? Escríbenos aquí.
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}
